<template>
  <div class="">
    <system-users />
    <new-account-invite />
  </div>
</template>

<script>
// @ is an alias to /src
import SystemUsers from '@/components/account/SystemUsers.vue';
import NewAccountInvite from '@/components/account/NewAccountInvite.vue';

export default {
  components: {
    SystemUsers,
    NewAccountInvite,
  },
};
</script>
